// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarLimitBanner__container___7zAXg","text":"SidebarLimitBanner__text___6+eNL"};